/**
* Hours JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hours component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    className: 'hours',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      this.getTodaysHours();
    },

    getTodaysHours: function() {
      const cacheBuster = new Date().getTime();
      $.ajax( {
        url: siteInfo.wpApiSettings.ll + 'get-todays-hours',
        type: 'POST',
        data: {
          _t: cacheBuster,
        },
        cache: false,
        beforeSend: function( xhr ) {
          xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
          xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
          xhr.setRequestHeader( 'Cache-Control', 'no-cache' );
          doingAjax = true;
        },
        success: function( response ) {
          $( '[data-todays-hours]' ).text( response.data );
        },
        complete: function() {
          doingAjax = false;
        },
        error: function( xhr, status, error ) {
          console.error( 'Error fetching today\'s hours:', error );
        },
      } );
    },

    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hours', COMPONENT );
} )( app );
